import React, { useState } from "react";
import { observer } from "mobx-react-lite";
import { InsuranceCompanyForm, Modal, Table, CogList } from "components";
import { useRootStore } from "store";
import getPageCount from "utils/getPageCount";
import { InsuranceCompany } from "interfaces";
import styles from "./InsuranceCompanyList.module.scss";
import { IInsuranceCompaniesList } from "./InsuranceCompaniesList";
import appStyles from "styles/app.module.scss";

const headersList = [{ header: "Name" }, { header: "" }];

const InsuranceCompaniesList: React.FC<IInsuranceCompaniesList.IProps> = observer(
  (props: IInsuranceCompaniesList.IProps) => {
    const [showModal, setShowModal] = useState(false);
    const { insuranceCompaniesStore } = useRootStore();
    const {
      activeInsuranceCompany,
      setActiveInsuranceCompany,
      data: {
        listItems: insuranceCompanies,
        meta: { page, totalCount, limit },
      },
      getInsuranceCompanies,
    } = insuranceCompaniesStore;

    const getCogActions = (insuranceCompany) => [
      {
        label: "Edit",
        fn: () => {
          setActiveInsuranceCompany(insuranceCompany);
          setShowModal(true);
        },
      },
    ];

    const renderinsuranceCompanies = (props: {
      item: InsuranceCompany;
      id: number;
    }) => {
      const { item: insuranceCompany, id } = props;
      return (
        <tr key={`insuranceCompany_${id}`}>
          <td>{insuranceCompany.name}</td>
          <td>
            <CogList actions={getCogActions(insuranceCompany)} />
          </td>
        </tr>
      );
    };

    return (
      <>
        <Table
          listItems={insuranceCompanies}
          headersList={headersList}
          totalCount={totalCount}
          pageCount={getPageCount(totalCount, limit)}
          renderItems={renderinsuranceCompanies}
          usePagination
          currentPage={page}
          initialPage={page >= 2 ? page - 1 : 0}
          handlePagination={async (page) => {
            await getInsuranceCompanies({ page });
          }}
          showAddBtn
          handleAdd={() => {
            setActiveInsuranceCompany({});
            setShowModal(true);
          }}
        />

        <Modal
          handleHide={() => {
            setShowModal(false);
            setActiveInsuranceCompany({});
          }}
          show={showModal}
          title={`${
            activeInsuranceCompany?.id ? "Edit" : "Create"
          } Insurance Company`}
        >
          <InsuranceCompanyForm
            insuranceCompany={activeInsuranceCompany}
            handleSubmit={() => {
              setShowModal(false);
              setActiveInsuranceCompany({});
            }}
          />
        </Modal>
      </>
    );
  }
);

export { InsuranceCompaniesList };
